<template>
  <Layout
    :backToRoute="!onlyLogoHeader ? true : false"
    :onlyLogoHeader="onlyLogoHeader"
  >
    <v-row
      class="primary--text section-title font-weight-bold"
      v-if="viewData.title"
    >
      <icon
        v-if="viewData.title.icon"
        :name="viewData.title.icon"
        :color="this.$vuetify.theme.themes.light.primary"
        width="30"
      ></icon>
      <v-icon v-else color="primary">{{ viewData.title.vicon }}</v-icon>
      {{ $t(`${viewData.title.text}`) }}
    </v-row>
    <v-row
      class="flex-column align-center justify-center text-center px-8 primary--text pt-15"
    >
      <icon
        v-if="viewData.primary_text.icon"
        :name="viewData.primary_text.icon"
        :color="this.$vuetify.theme.themes.light.primary"
        width="30"
      ></icon>
      <v-icon v-else color="primary" class="big-icon my-6">{{
        viewData.primary_text.vicon
      }}</v-icon>
      <span
        v-if="viewData.primary_text.text"
        class="display font-weight-bold"
        >{{ $t(`${viewData.primary_text.text}`) }}</span
      >
      <span v-if="viewData.secondary_text" class="mt-12 font-weight-light">{{
        $t(`${viewData.secondary_text}`)
      }}</span>
    </v-row>
    <v-row class="pt-10">
      <v-btn
        color="primary"
        class="textOverSecondary--text semi-rounded my-8 mx-auto px-12 py-8"
        @click="
          $router.push({
            name: viewData.redirectTo
              ? routeNames[viewData.redirectTo]
              : routeNames.WALLET,
          })
        "
      >
        {{
          viewData.dismiss_action ? viewData.dismiss_action : $t("actions.ok")
        }}
      </v-btn>
    </v-row>
  </Layout>
</template>
<script>
import Layout from "@/views/layouts/MainLayout";

export default {
  props: {
    viewData: Object,
    routeNames: Object,
    onlyLogoHeader: {
      default: false,
    },
  },
  components: {
    Layout,
  },
};
</script>
